module.exports = __webpack_public_path__ + "img/lazyload.8e08e21a.jpg";